<div class="flex flex-col items-center pt-16">
  <div class="pt-4 pb-4 flex flex-col mx-auto my-auto justify-center">
    <div class='flex justify-center'>
      <img alt="Logo" class="w-64" src="logo-no-border.png"/>
    </div>
    <div class='uppercase font-bold text-2xl text-center text-blue-600 mt-8'>404 Error</div>

    <div class="font-black text-6xl text-center my-8">Page not found</div>
    <div class='text-center font-semibold text-lg'>Sorry we couldn't find he page you are looking.</div>

    <div class='flex justify-center mt-8'>
      <a class="btn btn-outline btn-primary btn-lg width-100x" routerLink="/">
        Go Back
      </a>
    </div>
  </div>
<!--  <div class="container pl-5 pr-5 pt-5 pb-5 mb-auto text-dark font-size-30">-->
<!--    <div class="font-weight-bold text-3xl text-center mb-3">Page not found</div>-->
<!--    <div class='text-center'>This page is deprecated, deleted, or does not exist at all</div>-->
<!--    <div class="font-bold text-gray-500 text-6xl my-8 text-center mb-1">404 —</div>-->

<!--  </div>-->
  <div class="mt-auto pb-5 pt-5">
    <!--    <ul  class="footerNav hidden list-unstyled d-flex mb-2 flex-wrap justify-content-center">-->
    <!--      <li>-->
    <!--        <a href="javascript: void(0);">Terms of Use</a>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--        <a href="javascript: void(0);">Compliance</a>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--        <a href="javascript: void(0);">Support</a>-->
    <!--      </li>-->
    <!--    </ul>-->
    <div class="text-gray-4 text-center">© 2022 BusPro. All rights reserved.</div>
  </div>
</div>
